/**
 * Pure utility functions that don't depend on config
 * These can be imported by config.ts without creating circular dependencies
 */

// import { Environment } from './types';

/**
 * Parse comma-separated domain list
 */
export function parseAllowedDomains(domainsString: string): string[] {
  return domainsString
    .split(',')
    .map(domain => domain.trim())
    .filter(Boolean);
}

/**
 * Generate CSP connect-src directive
 */
export function generateCSPConnectSrc(
  allowedDomains: string[],
  stripeDomains: string[],
  stytchDomains: string[],
  sentryDomains: string[]
): string {
  const connectSources = [
    "'self'",
    ...allowedDomains,
    ...stripeDomains,
    ...stytchDomains,
    ...sentryDomains,
    // WebSocket protocols
    ...allowedDomains.map(domain => domain.replace('http://', 'ws://')),
    ...allowedDomains.map(domain => domain.replace('https://', 'wss://')),
  ];
  
  return [...new Set(connectSources)].join(' ');
}

/**
 * Check if a URL is in the allowed domains list (pure version)
 */
export function isAllowedDomainPure(url: string, allowedDomains: string[]): boolean {
  try {
    const urlObj = new URL(url);
    const origin = urlObj.origin;
    
    return allowedDomains.some(allowed => {
      // Handle wildcards
      if (allowed.includes('*')) {
        const pattern = allowed
          .replace(/\./g, '\\.')
          .replace(/\*/g, '.*');
        return new RegExp(`^${pattern}$`).test(origin);
      }
      return origin === allowed;
    });
  } catch {
    return false;
  }
}